import { Injectable } from '@angular/core';

import { getDateForOffset } from '@frontend/sports/common/core/utils/date';

@Injectable({ providedIn: 'root' })
export class UpcomingTimeIntervalService {
    getInterval(): { fromDate: string; toDate: string } {
        const now = new Date();

        return {
            fromDate: this.getFormattedDate(now, 0),
            toDate: this.getFormattedDate(now, 1),
        };
    }

    private getFormattedDate(baseDate: Date, daysOffset: number): string {
        const minutesOffset = daysOffset * 24 * 60;
        const date = getDateForOffset(baseDate, minutesOffset);

        return date.toISOString();
    }
}
